var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M9.375 14.607a.41.41 0 0 1 .4-.42h2.733c.221 0 .4.188.4.42a.41.41 0 0 1-.4.422H9.775a.41.41 0 0 1-.4-.421Zm0-1.964a.41.41 0 0 1 .4-.421h4.067c.22 0 .4.188.4.42 0 .233-.18.422-.4.422H9.775c-.22 0-.4-.189-.4-.421m0-1.965a.41.41 0 0 1 .4-.421h3.867c.22 0 .4.188.4.42a.41.41 0 0 1-.4.422H9.775a.41.41 0 0 1-.4-.421"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M15.708 6.748h-2.573c-.15-.645-.702-1.123-1.36-1.123s-1.21.478-1.36 1.123H7.708c-.736 0-1.333.628-1.333 1.403v7.72c0 .775.597 1.403 1.333 1.403h4.8-.133.142a.41.41 0 0 0 .391-.42.41.41 0 0 0-.4-.422h-4.8a.55.55 0 0 1-.533-.561V8.15c0-.31.239-.561.533-.561h1v.561c0 .388.299.702.667.702h4.667c.368 0 .666-.314.666-.702v-.56h1c.295 0 .534.251.534.561v3.299c0 .232.179.42.4.42.22 0 .4-.188.4-.42v-3.3c0-.775-.597-1.403-1.334-1.403Zm-3.933.842a.48.48 0 0 0 .467-.491.48.48 0 0 0-.467-.492.48.48 0 0 0-.467.492.48.48 0 0 0 .467.49Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M17.25 15.938a.263.263 0 0 0-.262-.263h-.6v-.6a.263.263 0 0 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .146.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M18.375 15.938a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.687a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-to-list.a43e3aa9.svg";